<template>
  <div>
    <template v-if="onlyHide">
      <div v-show='!loading'><slot /></div>
    </template>
    <template v-if="!onlyHide">
      <slot v-if='!loading' />
    </template>
    <div v-if="loading" :class="{ 'my-5': !isSmall }">
      <div class="text-xs-center">
        <v-progress-circular
          :size="isSmall ? 32 : (showProgress ? 100 : 64)"
          :indeterminate="!showProgress"
          class="purple--text"
          :width="showProgress ? 15 : 4"
          :value="showProgress ? progress: null"
          :rotate="showProgress ? -90 : 0"
        >
          <span v-if="showProgress">{{ progress }} %</span>
        </v-progress-circular>
      </div>

      <div class="text-xs-center">{{ description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    description: String,
    size: String,
    showProgress: Boolean,
    progress: Number,
    onlyHide: Boolean
  },
  computed: {
    isSmall () { return this.size === 'small' }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Loadable.vue?621edceb